


import React, { useState } from "react";
import {
    Card,
    Grid,
    Button,
    // Chip,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import apiRequest from "../../../../apiRequest";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog";

const BankInfoCard = ({
    bankInfo,
    loading,
    handleTaxAction,
    setSelectedId,
    setActionType,
    setReasonModalOpen,
    setPreviewImage,
    setPreviewOpen,
}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmData, setConfirmData] = useState(null);

    if (!bankInfo) {
        return (
            <Card sx={{ p: 3, minHeight: 250 }}>
                <MDBox
                    height="100%"
                    minHeight={200}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <MDTypography variant="body1" color="text.secondary">
                        No data found
                    </MDTypography>
                </MDBox>
            </Card>
        );
    }

    // ✅ Handle Approve Click: open confirm dialog first
    const handleApproveClick = () => {
        setConfirmData(bankInfo.id);
        setConfirmOpen(true);
    };

    // ✅ Confirm Approve: call handleTaxAction
    const handleConfirmApprove = async () => {
        setConfirmOpen(false);
        await handleTaxAction(bankInfo.id, "approved");
    };

    return (
        <Card sx={{ p: 3, minHeight: 250 }}>
            <MDTypography variant="h6" mb={2}>
                Bank Information
            </MDTypography>

            <Grid container spacing={2}>
                {/* Account Number */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Account Number</MDTypography>
                    <MDTypography variant="body2">
                        {bankInfo.account_no || "-"}
                    </MDTypography>
                </Grid>

                {/* Transit Number */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Transit Number</MDTypography>
                    <MDTypography variant="body2">
                        {bankInfo.transit_number || "-"}
                    </MDTypography>
                </Grid>

                {/* Financial Institute Number */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">
                        Financial Institute Number
                    </MDTypography>
                    <MDTypography variant="body2">
                        {bankInfo.fin_institute_no || "-"}
                    </MDTypography>
                </Grid>

                {/* Bank Name */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Bank Name</MDTypography>
                    <MDTypography variant="body2">
                        {bankInfo?.bank?.name_en || "-"}
                    </MDTypography>
                </Grid>

                {/* Account Holder */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Account Holder</MDTypography>
                    <MDTypography variant="body2">
                        {bankInfo.holder_name || "-"}
                    </MDTypography>
                </Grid>

                {/* Status
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Status</MDTypography>
                    <MDBox mt={0.5}>
                        <Chip
                            label={bankInfo.status}
                            size="small"
                            color={
                                bankInfo.status === "approved"
                                    ? "success"
                                    : bankInfo.status === "rejected"
                                        ? "error"
                                        : "warning"
                            }
                        />
                    </MDBox>
                </Grid> */}



                {/* Reason */}
                {bankInfo.reason && (
                    <Grid item xs={12} md={6}>
                        <MDTypography variant="caption">Reason</MDTypography>
                        <MDTypography variant="body2">
                            {bankInfo.reason}
                        </MDTypography>
                    </Grid>
                )}

                {/* PR Document */}
                {bankInfo.pr_photo && (
                    <Grid item xs={12} md={6}>
                        <MDTypography variant="caption">PR Document</MDTypography>
                        <MDBox
                            mt={1}
                            sx={{
                                width: 160,
                                height: 120,
                                borderRadius: 2,
                                overflow: "hidden",
                                border: "1px solid #e0e0e0",
                                cursor: "pointer",
                                "&:hover img": { transform: "scale(1.05)" },
                            }}
                            onClick={() => {
                                setPreviewImage(
                                    `${apiRequest.BASE_URL}/${bankInfo.pr_photo}`
                                );
                                setPreviewOpen(true);
                            }}
                        >
                            <MDBox
                                component="img"
                                src={`${apiRequest.BASE_URL}/${bankInfo.pr_photo}`}
                                alt="PR Document"
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease",
                                }}
                            />
                        </MDBox>
                    </Grid>
                )}
            </Grid>

            {/* ACTION BUTTONS */}
            <MDBox mt={3} display="flex" gap={1.5} justifyContent="flex-end">
                {/* Approve */}
                <Button
                    variant="outlined"
                    disabled={loading || bankInfo.status === "approved"}
                    onClick={handleApproveClick} // ✅ open confirm dialog
                    sx={{
                        bgcolor: "#fff",
                        color: "#2e7d32",
                        borderColor: "#2e7d32",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#1b5e20" },
                    }}
                >
                    Approve
                </Button>

                {/* Reject */}
                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(bankInfo.id);
                        setActionType("rejected");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#d32f2f",
                        borderColor: "#d32f2f",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#b71c1c" },
                    }}
                >
                    Reject
                </Button>

                {/* Request Info */}
                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(bankInfo.id);
                        setActionType("request_info");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#ed6c02",
                        borderColor: "#ed6c02",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#e65100" },
                    }}
                >
                    Request Info
                </Button>
            </MDBox>

            {/* CONFIRM DIALOG */}
            <ConfirmDialog
                open={confirmOpen}
                title="Approve Bank Info"
                description={`Are you sure you want to approve this bank info?`}
                confirmText="Yes, Approve"
                confirmColor="success"
                loading={loading}
                onClose={() => setConfirmOpen(false)}
                onConfirm={handleConfirmApprove} // ✅ Approve after confirmation
            />
        </Card>
    );
};

export default BankInfoCard;
